import { Component } from '@angular/core';
import {
  INPUT_VALUE_COVER_TYPE_SOFT,
  INPUT_VALUE_WRAPPING_STANDART,
} from '@shared/common/product';
import type { TBookAlias, TBookCover, TBookWrapping } from '@shared/jp/product';
import type { IBookPreview } from '@shared/jp/data/products';
import { REGION_NAME_ENGLISH_DEFAULT } from '@shared/jp/shipping/constants';
import { DiscountService } from 'src/app/services/discount.service';
import { ProductionService } from 'src/app/services/production.service';
import type { TSectionSteps } from '@studiobuki/web-core/lib/section-steps';
import { BehaviorSubject, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GiftBooks, GiftSteps } from './gift-buy-page.data';

@Component({
  templateUrl: './gift-buy-page.component.html',
  styleUrls: ['./gift-buy-page.component.scss'],
})
export class GiftBuyPageComponent {
  get alias() {
    return this._alias$.value;
  }

  set alias(value: TBookAlias | undefined) {
    this._alias$.next(value);
  }

  private _alias$ = new BehaviorSubject<TBookAlias | undefined>(undefined);

  public cover: TBookCover = INPUT_VALUE_COVER_TYPE_SOFT;

  public wrapping: TBookWrapping = INPUT_VALUE_WRAPPING_STANDART;

  /**
   * mapped with adding `SHIPPING_REGULAR_PRICE` to each `IPrice['value']`
   */
  public readonly Books: IBookPreview[] = GiftBooks;

  public readonly sectionSteps: TSectionSteps = GiftSteps;

  get book(): IBookPreview | undefined {
    const { alias, Books: _Books } = this;

    return alias && _Books.find((b) => b.alias === alias);
  }

  public shipping$ = this._productionService.getShippingRegular$(
    of({ booksCount: 1, regionName: REGION_NAME_ENGLISH_DEFAULT }),
  );

  public discount$ = this._alias$.pipe(
    switchMap(
      (alias) =>
        (alias && this._discountService.getDiscount$(alias)) || of(undefined),
    ),
  );

  public shippingDiscount$ = this.shipping$.pipe(
    switchMap((shippingMethod) =>
      this._discountService.getShippingDiscount$(shippingMethod.id),
    ),
  );

  constructor(
    private _productionService: ProductionService,
    private _discountService: DiscountService,
  ) {}
}
